import {
  Box,
  Flex,
  FlexProps,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { isLocateableStop, ItineraryStop } from "~/api/resources/Itineraries";
import { useMapContext } from "~/providers/MapContextProvider";
import { RefObject, createContext, useEffect, useRef } from "react";

type Props = FlexProps & {
  stop: ItineraryStop;
  show?: boolean;
};

type StopContextType = {
  ref: RefObject<HTMLDivElement>;
};

const StopContext = createContext<StopContextType>({
  ref: { current: null },
});

export const StopWrapper = ({ stop, children, show, ...props }: Props) => {
  const boxRef = useRef<HTMLDivElement>(null);
  // const { activePosition, setActiveStop, activeStop } = useMapContext();
  // useEffect(() => {
  //   const handleScroll = (event: Event) => {
  //     if (boxRef.current) {
  //       const { height, top } = boxRef.current.getBoundingClientRect();
  //       if (
  //         top <= activePosition &&
  //         top + height >= activePosition &&
  //         activeStop?.id !== stop.id &&
  //         stop.type !== "note"
  //       ) {
  //         setActiveStop({ id: stop.id, ref: boxRef });
  //       }
  //     }
  //   };
  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [activeStop?.id, activePosition, stop.id, stop.type, setActiveStop]);
  const default_show = useShowColumn();
  return (
    <StopContext.Provider value={{ ref: boxRef }}>
      <Flex p={8} ref={boxRef} {...props}>
        {show !== false && default_show && (
          <Box flexBasis={50} flexGrow={0} flexShrink={0}>
            <Text textStyle={{ base: "h4", md: "h2" }}>
              {isLocateableStop(stop) && stop.stop_number}
            </Text>
          </Box>
        )}
        <Box flexGrow={1}>{children}</Box>
      </Flex>
    </StopContext.Provider>
  );
};

export const useShowColumn = () =>
  useBreakpointValue({ base: false, md: true });
